export class NativeStreamAggregationSpans {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lateRows",
            "baseName": "lateRows",
            "type": "NativeStreamAggregationLateRows",
            "format": ""
        },
        {
            "name": "freezeDelayMinutes",
            "baseName": "freezeDelayMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "sealDelayMinutes",
            "baseName": "sealDelayMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "NativeStreamAggregationSpanLayout",
            "format": ""
        },
        {
            "name": "asOfReads",
            "baseName": "asOfReads",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationSpans.attributeTypeMap;
    }
    constructor() {
    }
}
